// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-components/build/generate-icons

import { arrowULeft16X16 } from '@ni/nimble-tokens/dist/icons/js';
import { IconSvg, registerIconSvg } from '../../icon-svg';

declare global {
    interface HTMLElementTagNameMap {
        'nimble-icon-arrow-u-left': IconArrowULeft;
    }
}

/**
 * The icon component for the 'arrowULeft' icon
 */
export class IconArrowULeft extends IconSvg {
    public constructor() {
        super(arrowULeft16X16);
    }
}

registerIconSvg('icon-arrow-u-left', IconArrowULeft);
export const iconArrowULeftTag = 'nimble-icon-arrow-u-left';
